<div class="registration-container">

    <div class="container">

        <app-header-for-open-pages></app-header-for-open-pages>
        
        <!-- <div class="row"> -->
            <!-- <div class="col-12"> -->

                <div class="form-inner">

                    <form class="form-registration" #f="ngForm" [formGroup]="registrationForm" autocomplete="off">

                        <div class="form-group">
                            <div class="input-group">
                                <!-- <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i octicon="person"></i>
                                    </div>
                                </div> -->
                                <label for="Email">{{ 'Логин' | translate }} <span class="star">*</span></label>
                                <input type="email" class="form-control" id="login" formControlName="login" placeholder="Введите e-mail">
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.login">
                                    <div class="text-error" *ngIf="validation('login', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <div class="input-group">
                                <!-- <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i octicon="lock"></i>
                                    </div>
                                </div> -->
                                <label for="password">{{ 'USERS.USERS_EDITOR.PASS' | translate }} <span class="star">*</span></label>
                                <input [type]="showPass ? 'text' : 'password'" class="form-control" formControlName="password" placeholder="Введите пароль">
                                <button class="hidePass" (keydown.H)="password('showPass')" (click)="password('showPass')">
                                    <svg-icon [src]="showPass ? '/assets/images/icons/eye.svg' : '/assets/images/icons/eye-close.svg'" [stretch]="true"
                                    [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                </button>
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.password">
                                    <div class="text-error" *ngIf="validation('password', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="form-group">
                            <div class="input-group">
                                <!-- <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i octicon="lock"></i>
                                    </div>
                                </div> -->
                                <label for="confirm_password">{{ 'Повторить пароль' | translate }} <span class="star">*</span></label>
                                <input [type]="showPassConfirm ? 'text' : 'password'" class="form-control" formControlName="confirm_password" placeholder="Введите пароль повторно">
                                <button class="hidePass" (keydown.H)="password('showPassConfirm')" (click)="password('showPassConfirm')">
                                    <svg-icon [src]="showPassConfirm ? '/assets/images/icons/eye.svg' : '/assets/images/icons/eye-close.svg'" [stretch]="true"
                                    [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                </button>
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.confirm_password">
                                    <div class="text-error" *ngIf="validation('confirm_password', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="form-group">
                            <div class="input-group">
                                <label for="second_name">{{ 'Фамилия' | translate }} <span class="star">*</span></label>
                                <input type="text" class="form-control" formControlName="second_name" placeholder="Введите фамилию">
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.second_name">
                                    <div class="text-error" *ngIf="validation('second_name', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="form-group">
                            <div class="input-group">
                                <label for="first_name">{{ 'Имя' | translate }} <span class="star">*</span></label>
                                <input type="text" class="form-control" formControlName="first_name" placeholder="Введите имя">
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.first_name">
                                    <div class="text-error" *ngIf="validation('first_name', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <!-- <div class="form-group">
                            <div class="input-group input-group_end">
                                <label for="last_name">{{ 'Ваше отчество' | translate }}</label>
                                <input type="text" class="form-control" formControlName="last_name" placeholder="Введите отчество">
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.last_name">
                                    <div class="text-error" *ngIf="validation('last_name', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div> -->
    
                        <div class="btn-tool">
                                <button type="button" class="btn btn-primary btn-reg" (click)="onConfirm(f)" [disabled]="registrationForm.invalid">Зарегистрироваться</button>
                            <div class="col-account-exists">
                                <div class="account-exists">
                                    <a routerLink="/login">{{ 'ACC_EXISTS' | translate }}</a>
                                </div>
                            </div>
                        </div>
    
                    </form>

                </div>



            <!-- </div> -->
        <!-- </div> -->
        
    </div>

</div>
